<template>
  <div class="">
    <router-view />
    <appAlert />
  </div>
</template>

<script>
import appAlert from "@/packages/dashboard/plugins/appAlert/appAlert";
export default {
  name: "ExamComponent",
  components: { appAlert },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Withdrawal/getExamWithdrawals");
      window.document.title = "KISEB::Examinations";
    });
  },
};
</script>

<style scoped></style>
